export function tableStriped(i: number) {
    return i % 2 === 0 ? "even" : "odd";
}
